export enum Bytes
{
    BYTE,
    KIBI,
    MIBI,
    GIBI,
    TEBI,
    PEBI
}
